<template>
  <div v-on:click="openDorm()" class="banner-card">
    <div class="banner-card__wrp">
      <img
        :src="banner.dorm.cover"
        v-if="banner.dorm.cover"
        alt="" class="banner-card__cover">
      <div class="banner-card__content" :style="{ background: convertHex(banner.color) }">
        <div class="banner-card__head">
          <div class="banner-card__title">{{ banner.top_title }}</div>
          <div class="banner-card__txt" :style="{ textShadow: `${banner.color} 2px 1px 1px` }">{{ banner.bottom_title }}</div>
        </div>
        <div class="banner-card-logo" v-if="banner.dorm.logo" >
          <img :src="banner.dorm.logo" alt="" class="banner-card-logo__img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'BannerItem',
  props: {
    banner: Object,
    to: [String, Object]
  },
  data () {
    return {
      branchedBanner: false,
      branches: [],
      opacity: 50
    }
  },
  methods: {
    string_to_slug (str) {
      str = str.replace('Yurtları', 'Yurtlari')
      str = str.replace('Öğrenci', 'Ogrenci')
      str = str.replace('Kız ', 'Kiz ')
      str = str.replace('ş', 's')
      str = str.replace('Ş', 'S')
      str = str.replace('ı', 'i')
      str = str.replace('I', 'i')
      str = str.replace('Ğ', 'G')
      str = str.replace('ğ', 'g')
      str = str.replace('Ü', 'U')
      str = str.replace('ü', 'u')
      str = str.replace('ö', 'o')
      str = str.replace('Ö', 'O')

      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    getDetail () {
      var self = this
      const url = self.$attrs.redirect ? `/site/dorm/detail/old/${this.to.params.id}` : `/site/dorm/detail/${this.to.params.id}`
      // const url = `/site/dorm/detail/${this.to.params.id}`
      axios.get(url)
        .then(response => {
          this.isLoading = false
          self.detail = response.data
          if (response.data.branches.length > 1) {
            window.localStorage.setItem('branchedDormId', this.to.params.id)
            window.localStorage.setItem('dormLogo', response.data.dorm.logo)
            window.localStorage.setItem('dormWeb', response.data.dorm.web)
            let dorm = this.string_to_slug(this.banner.top_title)
            let route = { name: 'BranchMain', params: { dorm: dorm } }
            self.$router.push(route)
            //  self.$router.push('/' + this.string_to_slug(this.banner.top_title) + '-subeler/')
          } else {
            if (this.$helpers.mobileCheck()) {
              self.$router.push(this.to)
            } else {
              window.open(window.location.origin + '/' + this.to.params.slug + '-y-' + this.to.params.id, '_blank')
            }
          }
        })
    },
    convertHex (color) {
      color = color.replace('#', '')
      let r = parseInt(color.substring(0, 2), 16)
      let g = parseInt(color.substring(2, 4), 16)
      let b = parseInt(color.substring(4, 6), 16)
      // let result = 'rgba(' + r + ',' + g + ',' + b + ',' + this.opacity / 100 + ')'
      let result = `linear-gradient(90deg,rgb(${r},${g},${b}) 15%,rgba(${r},${g},${b},.85) 40%,rgba(${r},${g},${b},0))`
      return result
    },
    openDorm () {
      this.getDetail()
    }
  },
  computed: {
    getMobile () {
      let result = this.mobileCheck()
      return result
    }
  },
  created () {
    if (this.banner.top_title.includes('Yurtları')) {
      window.localStorage.setItem('branchedDormTitle', this.banner.top_title)
    }
  }

}
</script>
<style lang="scss">
  @import "../assets/scss/components/banner";
</style>
